import React, { useEffect, useState } from "react";
import { postProcedimientoModificar,  postModificarProcedimientoUser, postProcedimientoVias } from "../../../services/PaginaRuta";
import ModalMedicoModificarProcedimiento from "./ModalMedicoModificarProcedimiento";
import ModalModificarListaSeleccionEspecialidad from "./ModalModificarListaSeleccionEspecialidad";
import ModalModificarSeleccionHonorariosCirujano from "./ModalModificarSeleccionHonorariosCirujano";

const ModalProcedimientosDeCirugia = ({setModalOnProcedimientoCirugia, item, passActua,user}) => {
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
  const [isAutoriza, setisAutoriza]=useState(false)
  const [dataAutoriza, setdataAutoriza]=useState('')
  const [dataProcedimiento, setDataProcedimiento] = useState([]);  
  const [modalOnModificarMedico, setmodalOnModificarMedico]= useState(false)
  const [modalOnModificarEspecialidad, setmodalOnModificarEspecialidad]=useState(false)
  const [modalOnModificarHonorariosCirujano, setmodalOnModificarHonorariosCirujano]=useState(false)
  const [errorEspecialidad, seterrorEspecialidad]=useState('')
  const [errorMedico, seterrorMedico]=useState('')
  const [errorHonorario, seterrorHonorario]=useState('')
  const [errorCantidad, seterrorCantidad]=useState('')
  const [dataVias,setdataVias]=useState([])
  const [viaUser, setviaUser]=useState('')
  const [dataChildModificarMedico, setdataChildModificarMedico]=useState({
    codigoMedico:'',
    nombreMedico:'',
    codigoEspecialidad:'',
    nombreEspecialidad:''
  })

  

  const [dataChildModificarHonorarios, setdataChildModificarHonorarios]=useState({
    HnrCod:'',
    HnrDsc:''
  })

  const passModificarHonorarios=(data)=>{
    setdataChildModificarHonorarios(data)
    seterrorHonorario('')
    
  }

  const passModificarMedico=(data)=>{
    seterrorMedico('')
    seterrorEspecialidad('')
    setdataChildModificarMedico(data)
    
  }

  const passChildModificarEspecialidad=(data)=>{
    //console.log(data,'dataaaespecialidad')
    
    seterrorEspecialidad('')
    setdataChildModificarMedico({
      codigoMedico:dataChildModificarMedico.codigoMedico,
      nombreMedico:dataChildModificarMedico.nombreMedico,
      codigoEspecialidad:data.codigoEspecialidad,
      nombreEspecialidad:data.nombreEspecialidad
    })
    
  }

  

  const handleOnsubmitModificarProcedimiento=(e)=>{
    e.preventDefault();
    console.log(dataAutoriza,'dataAutoriza')
    const bodyModificar={
      ProEmpCod:usuarioInfo.Empresa,
      ProMCDpto:usuarioInfo.Sede,
      ProCirCod: e.target.numeroCirugia.value,
      CrgCod: e.target.codigoProcedimiento.value,
      //CrgPrcCns:'1',
      CrgEst:'S',
      CrgCnt: e.target.cantidadProcedimiento.value,
      ViaCod: e.target.via.value,
      DesQx:'',
      MedCod: e.target.codigoMedico.value,
      EspcCod: e.target.codigoEspecialidad.value,
      CrgHnrCi:dataChildModificarHonorarios.HnrCod,
      CRGPRCAUT:dataAutoriza,
      CirFinCod:'',
      DiligencioDesQx:'No',      
    }
    //console.log(errorEspecialidad.length,'body Modificar')
    
    //CrgHnrCi:'01',
    if(errorEspecialidad == '' && errorHonorario=='' && errorMedico=='' && errorCantidad==''){
      postModificarProcedimientoUser(bodyModificar).then((res)=>{
        //console.log(res.data,'modificaciones')
        passActua(bodyModificar)
        setModalOnProcedimientoCirugia(false)
      }).catch((error) => {
        //console.error('Error al autenticar al usuario:', error);
        //seterrorEndpoint(true);
        //setLoading(true);
      });

    }
    
    
    
  }

  const handleOnclickModificarHonorariosCirujano=()=>{
    setmodalOnModificarHonorariosCirujano(true)
  }

  const handleOnclickModificarEspecialidad=()=>{
    setmodalOnModificarEspecialidad(true)
  }

  const handleOnclickModificarMedico =()=>{
    setmodalOnModificarMedico(true)
  }

  const handleCancelarClick=()=>{
    setModalOnProcedimientoCirugia(false)
  }
  useEffect(() => {
    //console.log(item,'itemIMPORTANTE')
    const body = {
      vaProEmpCod:  usuarioInfo.Empresa,
      varProMCDpto: usuarioInfo.Sede,
      varProCirCod: item.ProCirCod,
    };
    postProcedimientoModificar(body).then((res) => {
      setDataProcedimiento(res.data[0]);
      //console.log(res.data[0],'datos usuario paera modificar ')
      if(res.data[0].CRGPRCAUT === 'S'){
        setisAutoriza(true)
      }else if(res.data[0].CRGPRCAUT === 'N'){
        setisAutoriza(false)
      }
    });

    if(item.EspcCod == "0" || item.EspcCod==''){
      seterrorEspecialidad('Seleccionar una especialidad')
    }
    if(item.MedCod === "     " || item.MedCod === '' || item.MedCod === null){
      seterrorMedico('Seleccionar un Médico')
      
    }
    if(item.CrgHnrCi === '' || item.CrgHnrCi === "  "|| item.CrgHnrCi === null){
      seterrorHonorario('Seleccionar Honorario')
    }

    setdataChildModificarMedico(
      {
        codigoMedico: item.MedCod,
        nombreMedico:item.MedNom,
        codigoEspecialidad:item.EspcCod,
        nombreEspecialidad:item.EspcDes
      }
    )

    

    setdataChildModificarHonorarios({
      HnrCod: item.CrgHnrCi,
      HnrDsc: item.CrgHnCiD
    })

   
    postProcedimientoVias().then((res)=>setdataVias(res.data))
    setviaUser(item.ViaCod)
  }, []);
  const handleOnchangeAutoriza=()=>{
    setisAutoriza(!isAutoriza)
    //console.log(!isAutoriza,'!isAutoriza')
    if(!isAutoriza){
      setdataAutoriza('S')
    }else{
      setdataAutoriza('N')
    }
  }
  const handleOnchangeCantidad=(e)=>{
    //console.log(e.target.value,'cantidad')
    if(e.target.value){
      seterrorCantidad('')
    }else{
      seterrorCantidad('Seleccionar Cantidad')
    }
  }
  const handleOnchangeVia=(e)=>{
    setviaUser(e.target.value)
  }
  return (
    <>
      <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto  bg-[#f4f6fa]"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%)] max-w-7xl  mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-1 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
                Procedimientos de Cirugía
              </h5>
              <button
                type="button"
                onClick={handleCancelarClick}
                className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                X
              </button>
            </div>
            <div className="flex-auto overflow-y-auto relative p-4">
            <form onSubmit={handleOnsubmitModificarProcedimiento}>
            <div >
              
                <div className="w-1/3 px-4">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Autorizada?
                  </label>
                  <input
                  checked={isAutoriza}
                  onChange={handleOnchangeAutoriza}
                    autoComplete="off"
                    className="form-check-input  h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
                    type="checkbox"
                    name="valoracionPreanestesica"
                    id="flexCheckDefault"
                    //checked={reqValoracionPreanestesica}
                    //onChange={handleOnchangeReqValoracionPreanestesica}
                  />
                </div>
                <div className="flex flex-row py-2  text-left">
                  <div className="w-1/4  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      N° Cirugía
                    </label>
                    <input
                      autoComplete="off"
                      type="text"
                      disabled={true}
                      defaultValue={dataProcedimiento.ProCirCod}
                      name='numeroCirugia'
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/4  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Número Documento 
                    </label>
                    <input
                      autoComplete="off"
                      type="text"
                      disabled={true}
                      defaultValue={dataProcedimiento.MPCedu}
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/4  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Tipo Documento
                    </label>
                    <input
                      autoComplete="off"
                      type="text"
                      disabled={true}
                      defaultValue={dataProcedimiento.MPTDoc}
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                  <div className="w-1/4  px-1 ">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                      Nombre del Paciente
                    </label>
                    <input
                      autoComplete="off"
                      type="text"
                      disabled={true}
                      defaultValue={dataProcedimiento.MPNOMC}
                      className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                  </div>
                </div>
              
              <h5
                className="text-xl font-medium leading-normal text-gray-800 text-center pt-3"
                id="exampleModalScrollableLabel"
              >
                Procedimientos
              </h5>
              <div className="flex text-left pt-2">
                <div className="w-1/4  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Procedimiento
                  </label>
                  <input
                    autoComplete="off"
                    type="text"
                    disabled={true}
                    defaultValue={item.CrgCod}
                    name='codigoProcedimiento'
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                </div>
                <div className="w-3/4 px-1 pt-2">
                  <textarea
                    autoComplete="off"
                    disabled={true}
                    defaultValue={item.CrgDes}
                    //onChange={handleOnchangeReqMaterialesEspecialesTextArea}
                    //value={reqDispEquiposEspecialesTextArea}
                    //disabled={!reqMaterialesEspeciales}
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-700  bg-white bg-clip-padding border border-solid border-gray-300 rounded
                          transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    id="exampleFormControlTextarea1"
                    rows="2"
                    placeholder=""
                  ></textarea>
                </div>
              </div>

              <div className="flex py-2 text-left">
                <div className="w-1/3  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Cantidad
                  </label>
                  <input
                    autoComplete="off"
                    type="number"
                    //disabled={true}
                    defaultValue={item.CrgCnt}//se puede cambiar
                    onChange={handleOnchangeCantidad}
                    name='cantidadProcedimiento'
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                  <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                        {errorCantidad}
                    </label>
                </div>
                <div className="w-2/3  px-1">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Vía
                  </label>
                  <div className="">
                    
                    <select
                          value={viaUser}
                          onChange={handleOnchangeVia}
                          name="via"
                          className="form-select block  w-full px-2 py-0.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                          aria-label="Default select example"
                        >
                          {dataVias.map((item) => (
                            <option value={item.ViaCod} key={item.ViaCod}>
                              {item.ViaDsc}
                            </option>
                          ))}
                        </select>
                  </div>
                </div>
              </div>
              <div className="flex  text-left">
                <div className="w-1/3  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Código Médico
                  </label>
                  <input
                    autoComplete="off"
                    type="text"
                    onFocus={handleOnclickModificarMedico}
                    defaultValue={dataChildModificarMedico.codigoMedico}
                    name='codigoMedico'
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    readOnly
                  />
                  <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                        {errorMedico}
                    </label>
                </div>
                <div className="w-2/3  px-4">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Médico
                  </label>
                  <input
                    autoComplete="off"
                    defaultValue={dataChildModificarMedico.nombreMedico}
                    disabled={true}
                    type="text"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                </div>
              </div>
              <div className="flex  text-left">
                <div className="w-1/3  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Código Especialidad
                  </label>
                  <input
                    autoComplete="off"
                    onFocus={handleOnclickModificarEspecialidad}
                    defaultValue={dataChildModificarMedico.codigoEspecialidad}
                    name='codigoEspecialidad'
                    type="text"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    readOnly
                  />
                  <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                        {errorEspecialidad}
                    </label>
                </div>
                <div className="w-2/3  px-1">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Especialidad
                  </label>
                  <input
                    autoComplete="off"
                    type="text"
                    defaultValue={dataChildModificarMedico.nombreEspecialidad}
                    disabled={true}
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                </div>
              </div>
              <div className="flex  text-left">
                <div className="w-1/3  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Código Honorario
                  </label>
                  <input
                    autoComplete="off"
                    type="text"
                    onFocus={handleOnclickModificarHonorariosCirujano}
                    defaultValue={dataChildModificarHonorarios.HnrCod}
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    readOnly
                  />
                  <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                        {errorHonorario}
                    </label>
                </div>
                <div className="w-2/3  px-1">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Descripción Honorario
                  </label>
                  <input
                    autoComplete="off"
                    type="text"
                    defaultValue={dataChildModificarHonorarios.HnrDsc}
                    disabled={true}
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                </div>
              </div>
            </div>
            
            <div className="flex  flex-wrap items-center justify-end py-2 border-t border-gray-200 rounded-b-md">
              <button
                type="button"
                onClick={handleCancelarClick}
                className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
                data-bs-dismiss="modal"
              >
                Cancelar
              </button>
              <button type="submit"
                className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
                Guardar
              </button>
            </div>
            </form>
            </div>
          </div>
        </div>
      </div>
      {modalOnModificarMedico? <ModalMedicoModificarProcedimiento setmodalOnModificarMedico={setmodalOnModificarMedico} passModificarMedico={passModificarMedico}/>:null}
      {modalOnModificarEspecialidad? <ModalModificarListaSeleccionEspecialidad setmodalOnModificarEspecialidad={setmodalOnModificarEspecialidad} passChildModificarEspecialidad={passChildModificarEspecialidad} dataChildModificarMedico={dataChildModificarMedico.codigoMedico}/>:null}
      {modalOnModificarHonorariosCirujano? <ModalModificarSeleccionHonorariosCirujano setmodalOnModificarHonorariosCirujano={setmodalOnModificarHonorariosCirujano} passModificarHonorarios={passModificarHonorarios} item={item} user={user}/>:null}
    </>
  );
};

export default ModalProcedimientosDeCirugia;
